import { ModalAppearance } from './modal-appearance/modal-appearance';
import { ModalProps } from './types';
import { Modal as JuicyModal } from '@vtbhome/juicyfront';

export const Modal: React.FC<ModalProps> = ({ isShow, ...props }) => {
    return (
        <ModalAppearance isShow={isShow}>
            <JuicyModal {...props} />
        </ModalAppearance>
    );
};
